import React from 'react';
import { Line } from 'react-chartjs-2';
import { View } from "react-native-web";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(LineElement, CategoryScale, LinearScale, PointElement, Tooltip, Legend);

const LineChart = ({ data }) => {
    const formatDate = (date) => {
        const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      
        const d = new Date(date); // Create a date object from the input date string
        const dayOfWeek = days[d.getUTCDay()]; // Get the day of the week (Sun, Mon, etc.) in UTC
        const dayOfMonth = d.getUTCDate(); // Get the day of the month in UTC
        const month = months[d.getUTCMonth()]; // Get the month (Jan, Feb, etc.) in UTC
        const year = d.getUTCFullYear().toString().slice(-2); // Get the last two digits of the year (e.g., 25 for 2025)
      
        // Determine the suffix for the day of the month (st, nd, rd, th)
        const suffix = (dayOfMonth % 10 === 1 && dayOfMonth !== 11) ? 'st' :
                       (dayOfMonth % 10 === 2 && dayOfMonth !== 12) ? 'nd' :
                       (dayOfMonth % 10 === 3 && dayOfMonth !== 13) ? 'rd' : 'th';
      
        return `${dayOfWeek} ${dayOfMonth}${suffix} ${month}`;
      };
    // Function to calculate total score per day
    const calculateTotalScores = () => {
      const allEntries = [...data['4'], ...data['5'], ...data['6']];
      const scoreByDate = {};
  
      allEntries.forEach(entry => {
        const date = new Date(entry.date); // Create date object
        const dateString = date.toISOString().split('T')[0]; // Extract the date part (yyyy-mm-dd)
  
        if (!scoreByDate[dateString]) {
          scoreByDate[dateString] = 0;
        }
        scoreByDate[dateString] += entry.score;
      });
  
      return Object.entries(scoreByDate).map(([date, totalScore]) => ({
        x: formatDate(date), // Use the formatted date for the x-axis
        y: totalScore,
      }));
    };
  
    const chartData = {
      datasets: [
        {
          label: 'Total Score per Day',
          data: calculateTotalScores(),
          borderColor: "#27ae60",
          backgroundColor: "#27ae60",
          tension: 0.4,
        },
      ],
    };
  
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        x: {
          type: 'category',
          title: {
            display: true,
            text: 'Date',
          },
        },
        y: {
          title: {
            display: true,
            text: 'Total Score',
          },
          min: 0,
        },
      },
      plugins: {
        legend: {
          position: 'top',
        },
        tooltip: {
          callbacks: {
            label: (context) => `Score: ${context.raw.y}`,
          },
        },
      },
    };
  
    return (
      <View style={{ width: '100%', height: '400px' }}>
        <Line data={chartData} options={options} />
      </View>
    );
  };
  

export default LineChart;
